const cancel = 'Zrušiť'
const save = 'Uložiť'

export default {

  global: {
    generalError: 'Ojoj! Žiadosť sa nepodarilo spracovať. Načítajte stránku znova.',
    signature: 'S pozdravom,',
  },

  component: {
    actionBar: {
      actions: 'Actions',
      hideActions: 'Hide actions',
    },

    addButton: {
      add: 'Add',
    },

    attachments: {
      add: 'Pridajte CV alebo iné požadované prílohy',
      placeholderWithDescription: 'Pridať požadované prílohy',
      remove: 'Odstrániť',
      allowedFileTypes: 'Povolené typy súboru',
      errors: {
        size: 'Súbor je príliš veľký. Maximálna veľkosť súboru je 5MB.',
        empty: 'Súbor neobsahuje žiadne údaje',
        invalidType: fileType => `Ľutujeme, súbory ${fileType} nie sú z bezpečnostných dôvodov povolené`,
        typeNotWhitelisted: 'Ľutujeme, typ súboru nie je povolený.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Pravidlá ochrany súkromia',
      termsLinkText: 'Zmluvné podmienky',
      privacyPolicyText: 'Vážime si vaše súkromie. Prečítajte si naše ',
      termsText1: 'Prečítajte si a prijmite ',
      termsText2: ', skôr ako nám poskytnete svoje osobné údaje.',
      privacyLink: 'https://new.recright.com/privacy-policy',
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `Ak nechcete, aby sme spracúvali vaše osobné údaje, môžete nás požiadať o odstránenie tak, že nám odošlete e-mail na ${mail}.`,
      customSupportPrivacyInfo: link => `Ak nechcete, aby sme spracúvali vaše osobné údaje, kontaktujte nás na adrese ${link} a požiadajte o odstránenie.`,
    },

    buttons: {
      close: 'Zatvoriť',
    },

    competencies: {
      addCompetency: 'Add a new competency',
      edit: 'Edit competencies',
      done: 'Done',
      defaultsDescription: 'If you are unsure what competencies to use, we have defined some good defaults to start with.',
      getDefaults: 'Get default competencies',
    },

    competency: {
      warning: 'Remove competency and all its ratings?',
    },

    confirmDelete: {
      delete: 'Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
    },

    confirm: {
      cancel: 'Odstrániť pokus',
      confirm: 'Skúsiť znova',
    },

    confirmButton: {
      wait: count => `Počkajte ${count}`,
      confirm: 'Potvrdiť',
    },

    controlStatus: {
      text: {
        empty: 'Vyplniť',
        valid: () => 'Pripravené',
      },
      textarea: {
        empty: 'Vyplniť',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Nastaviť',
        valid: () => 'Pripravené',
      },
      file: {
        empty: 'Vybrať',
        valid: () => 'Zmeniť',
      },
      list: {
        empty: 'Pridať',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Vyhľadať',
        valid: () => 'Pripravené',
      },
    },

    cookieConsentModal: {
      title: 'Naša webová stránka používa súbory cookie',
      body: 'Akceptovaním všetkých súborov cookie súhlasíte s ich ukladaním vo vašom zariadení na zlepšenie navigácie na stránke, analýzu používania stránky a na naše marketingové účely.',
      learnMoreLinkText: 'Viac informácií o tom, ako používame súbory cookie',
      learnMoreLink: 'https://new.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'Spravovať súbory cookie',
      acceptAll: 'Prijať všetky súbory cookie',
      manageTitle: 'Spravovať preferencie súhlasu',
      necessaryCookiesTitle: 'Nevyhnutné súbory cookie',
      necessaryCookiesBody:
        'Tieto súbory cookie sú nevyhnutné na fungovanie webovej stránky a nie je možné ich v našich systémoch vypnúť.',
      performanceCookiesTitle: 'Súbory cookie na zvýšenie výkonu',
      performanceCookiesBody:
        'Tieto súbory cookie nám umožňujú počítať návštevy a zdroje návštevnosti, aby sme mohli merať a zlepšovať výkonnosť našej stránky.',
      confirmChoices: 'Potvrdiť moje voľby',
      marketingCookiesTitle: 'Marketingové súbory cookie',
      marketingCookiesBody:
        'Tieto súbory cookie nám umožňujú prispôsobiť reklamu a merať jej výkonnosť.',
      functionalCookiesTitle: 'Funkčné súbory cookie',
      functionalCookiesBody:
        'Tieto súbory cookie sa používajú na zlepšenie funkčnosti webovej stránky. Bez týchto súborov cookie môžu byť niektoré funkcie nedostupné. Medzi príklady funkčných súborov cookie patria služby webového chatu a predvoľby používateľov.',
    },

    emailAddresses: {
      remove: 'Odstrániť',
      importCsv: 'Import CSV',
      invalidEmails: 'Invalid emails found.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'The csv rows can have email or email,phone. Each row represents a recipient. The phone numbers needs to be in international format (E.164) e.g. (<strong>+358</strong>50xxxxxxx).',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'Email bounced back. Make sure the recipient received your message.',
      },
      Permanent: {
        General: 'Email delivery failed. Recipients email provider rejected the message.',
        NoEmail: 'Email address does not exist.',
        Suppressed: 'Email was not delivered due to previous unsuccessful delivery attempts.',
      },
      Transient: {
        General: 'Email bounced back. Make sure the recipient received your message.',
        MailboxFull: 'Recipient inbox is full.',
        MessageTooLarge: 'The message content is too large.',
        ContentRejected: 'The message content rejected.',
        AttachmentRejected: 'The attachment rejected.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'The number given is already attatched to a candidate in the interview.',
    },

    error403: {
      heading: 'Zakázané',
      content: 'Náš server slušne (no jednoznačne) odmietol splniť žiadosť vášho prehliadača. Upozorňujeme, že Recright sa môže používať iba na jednom zariadení/prehliadači (súčasne).',
      link: 'Predná stránka',
    },

    error404: {
      heading: 'Tu nič nie je',
      content: 'Naozaj sme sa snažili, no na zadanej adrese sa nenachádza žiadna webová stránka. Možno ste použili neaktuálny odkaz alebo ste omylom napísali nesprávnu adresu.',
      link: 'Predná stránka',
    },

    error410: {
      heading: 'Zatvorené',
      content: 'Zamestnanie nie je možné ukázať, pretože je buď zatvorené, alebo obdobie podávania žiadostí skončilo.',
      link: 'Predná stránka',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    flash: {
      starting: 'Inicializuje sa...',
      connection_error_hint: 'Nepodarilo sa vytvoriť sieťové pripojenie.\nSkúste stránku načítať znova.',
      permission_hint: 'Tejto stránke musíte povoliť používať vašu webovú kameru a mikrofón.',
      searching_camera_hint: 'Hľadá sa webová kamera...',
      camera_reserved_hint: 'Vašu webovú kameru si rezervovala iná aplikácia alebo webová stránka. Zatvorte spomínanú aplikáciu a načítajte túto stránku znova.',
      camera_reserved_hint_chrome_extra: 'Vážený používateľ Chromu, službe Recright musíte v dialógovom okno pod lištou adresy povoliť používanie webovej kamery.',
      no_camera_hint: 'Webová kamera sa nenašla.',
      no_mic_hint: 'Mikrofón sa nenašiel.',
      uploading_text: 'Nahráva sa...',
      rtmpt_in_use: 'Tento krok by nebol potrebný, keby správca vašej siete povoľoval RTMP. Spýtajte sa nás ako.',
      preview_text: 'Webová kamera je v režime ukážky',
      close_text: 'Zatvoriť kameru',
      remove_text: 'Odstrániť pokus',
      noflash_errortext_install: link => `Zdá sa, že nemáte prehrávač Adobe Flash Player. Na nahrávanie videí potrebujete doplnok Flash. Získajte Flash tu: ${link}`,
      noflash_errortext_enable: link => `Ak ste Flash už nainštalovali, no táto správa sa vám stále zobrazuje, kliknite tu: ${link}`,
      noflash_errortext_differentbrowser: 'Prípadne môžete vyskúšať prehliadač, ktorý podporuje nahrávanie vo formáte HTML5. Odporúčame Chrome alebo Firefox.',
    },

    footer: {
      terms: 'Zmluvné podmienky',
      license: 'General Terms of Service',
      privacyPolicy: 'Pravidlá ochrany súkromia',
      customSupport: link => `Kontaktujte ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'Ako hodnotíte svoj dojem z pohovoru?',
      howWouldYouRateJobAd: 'Ako by ste ohodnotili svoje skúsenosti s aplikáciou?',
      yourResponseIsAnonymous: 'Vaša odpoveď je anonymná.',
      thankYouFeedback: 'Ďakujeme za vašu spätnú väzbu!',
    },

    candidateFooter: {
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://new.recright.com/privacy-policy',
      accessibilityReportLink: 'https://new.recright.com/hubfs/RecRight_Accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: 'Ľutujeme, typ súboru nie je povolený.',
      isRequired: 'Toto pole je povinné.',
      isEmail: value => `${value} nie je platný e-mail.`,
      isDate: value => `${value} nie je platný dátum.`,
      invalidUrl: 'Webová adresa je neplatná.',
      singleHireEndError: 'Jediné najatie nie je možné používať viac než 60 dní.',
      isNotTooOldForLive: 'Dátum je v minulosti.',
      isNotAfterEndDate: 'The date is after the date the job ad closes.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Phone number has already been added.',
      duplicateCompetency: 'Competency with that name already exists',
      isNotDuplicateTemplateName: 'Template with that name already exists',
    },

    jobAdApplication: {
      name: 'Názov',
      city: 'Rodné mesto',
      email: 'E-mail',
      phone: 'Telefónne číslo',
      applyForPosition: 'Uchádzať sa o pozíciu',
      back: 'Späť',
      continue: 'Pokračovať',
      submit: 'Odoslať',
      saveForLater: 'Pokračovať neskôr',
      namePlaceholder: 'Zadajte svoje meno',
      emailPlaceholder: 'Zadajte svoju e-mailovú adresu',
      phonePlaceholder: 'Zadajte svoje telefónne číslo',
      cityPlaceholder: 'Zadajte svoje súčasné domovské mesto',
      links: 'Pridajte odkazy, napríklad odkaz na svoj profil LinkedIn',
      legendBasicInfo: 'Základné informácie',
      legendLinks: 'Odkazy',
      legendAttachments: 'Prílohy',
      legendAdditionalFields: 'Doplňujúce informácie',
      coverLetter: 'Sprievodný list',
      attachments: 'Prílohy',
      introduction: 'Tu sa stručne predstavte',
      thankYou: 'Ďakujeme.',
      luck: 'Prajem vám veľa šťastia!',
      close: 'Zatvoriť',
      required: 'Položky označené hviezdičkou * sú povinné.',
    },

    jobAdContainer: {
      endTime: date => (date ? `otvorené do ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'Podať žiadosť o zamestnanie',
    },

    jobAdQuickInterview: {
      back: 'Späť',
      submit: 'Odoslať',
      saveForLater: 'Pokračovať neskôr',
      title: 'Stručný video pohovor',
      description: 'Boli by sme radi, keby ste odpovedali na stručnú otázku pohovoru, aby sme sa s vami rýchlejšie zoznámili. Predveďte svoju osobnosť a dodajte svojej a žiadosti dušu.',
      requiredNote: 'Upozorňujeme, že ide o jednu časť procesu podávania žiadosti a náborový zamestnanec dostane vašu žiadosť až potom, ako zaznamenáte svoju odpoveď.',
      reminderNote: 'Odpoveď môžete nahrať okamžite alebo môžete pokračovať neskôr po prijatí pripomenutia na e-mail.',
    },

    jobAdRow: {
      responses: 'Žiadosti',
      status: {
        open: 'Otvorené',
        filled: 'Vyplnené',
        cancelled: 'Zrušené',
        done: 'Hotovo',
        close: 'Zatvoriť',
        draft: 'Zatvorené (koncept)',
        hidden: 'Skryté',
      },
    },

    interviewRow: {
      responses: 'Uchádzači',
    },

    loadingButton: {
      loading: 'Načítava sa...',
      saving: 'Ukladá sa...',
      sending: 'Odosiela sa...',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'Zobraziť profil LinkedIn',
    },

    linkedInButton: {
      error: 'Pri načítavaní profilu sa vyskytol problém. Skúste to znova.',
      buttonText: 'Podať žiadosť cez LinkedIn',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'Môžete použiť svoj profil LinkedIn na predbežné vyplnenie formulára žiadosti',
      linkedInOr: 'Alebo',
      error: 'Pri načítavaní profilu sa vyskytol problém. Skúste to znova.',
    },

    linkListInput: {
      addField: 'Pridať',
      removeField: 'Odstrániť',
      invalidUrl: 'Webová adresa je neplatná.',
    },

    liveRoom: {
      greeting: name => `Hello, ${name}.`,
      notYetStarted: startTime =>
        `The interview has not yet started. The interview starts at ${startTime}.`,
      interviewTitle: title => `Interview title: ${title}`,
      interviewStartsIn: timeLeft => `The Interview starts in: ${timeLeft}`,
      interviewHasEnded: 'The interview has ended.',
    },

    modalApplicationForm: {
      applyForPosition: 'Uchádzať sa o pozíciu',
      continue: 'Pokračovať',
      name: 'Zadajte svoje meno',
      email: 'Zadajte svoju e-mailovú adresu',
      phoneNumber: 'Zadajte svoje telefónne číslo',
      links: 'Môžete zadávať odkazy',
      legendLinks: 'Odkazy',
      legendAttachments: 'Prílohy',
      coverLetter: 'Sprievodný list',
      attachments: 'Prílohy',
      introduction: 'Tu sa predstavte',
      thankYou: 'Ďakujeme.',
      luck: 'Prajem vám veľa šťastia!',
      close: 'Zatvoriť',
    },

    modalConfirm: {
      cancel,
      confirm: 'OK',
    },

    modalAlert: {
      close: 'Close',
    },

    modalLinkShare: {
      title: 'Zdielateľný verejný odkaz',
      info: 'Tu je verejná adresa pracovného inzerátu, ktorú môžete zdieľať.\nPracovný inzerát môže vidieť ktokoľvek, kto má o pozíciu záujem,\na následne sa môže rozhodnúť podať si žiadosť.\nKeď začnú prichádzať žiadosti, dostanete zvyčajné upozornenie.\n\nTu je verejný odkaz pracovného inzerátu:',
    },

    modalVideoAdd: {
      title: 'Pridať nové video',
      chooseTitle: 'Pridať nové video',
      titlePlaceholder: 'Sem zadajte názov videa',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Nahrať nové video',
      info: 'Maximálna povolená veľkosť videa je 500 MB. Odporúčame vám tieto videá pred nahraním skomprimovať. Nahrávanie a konverzia tak potrvajú kratšie.',
    },

    modalCandidateInfo: [
      {
        headline: 'Nahrajte svoju odpoveď vo forme videa ',
        content: 'koľkokrát chcete. Videá sa uložia okamžite po nahraní a do video pohovoru sa môžete vrátiť prostredníctvom odkazu, ktorý ste dostali na svoj e-mail.',
        mobileContent: 'koľkokrát chcete. Pridajte do pohovoru video. Uvidíte, ako sa v rámci pohovoru video nahrá a uloží. Do video pohovoru sa môžete vrátiť prostredníctvom odkazu, ktorý ste dostali na svoj e-mail. <br><br><strong>Ak vaša obrazovka videa zostáva čierna a používate mobilné zariadenie Apple, pokyny, ako tento problém vyriešiť, nájdete <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">tu</a>.</strong>',
      },
      {
        headline: 'Po nahraní ',
        content: 'sa ubezpečte, že video sa prehráva správne a váš hlas je počuť. Keď stlačíte tlačidlo Odoslať, vaša odpoveď sa uzamkne a už ju viac nebudete môcť upraviť.',
      },
      {
        headline: 'Keď dokončíte pohovor, ',
        content: 'stlačte tlačidlo Odoslať odpovede a dokončiť pohovor. Potom sa do video pohoru už nebudete môcť vrátiť. Ak si prajete túto stránku zatvoriť, no chcete v pohovore pokračovať neskôr, stlačte tlačidlo Pokračovať neskôr.',
      },
      {
        headline: 'Ak potrebujete pomoc ',
        content: mailto => `pri odpovedaní na video pohovor, kliknite na tlačidlo Pomoc v pravej dolnej časti stránky alebo nám odošlite e-mail na adresu ${mailto}.`,
        customContent: link => `Kontaktujte ${link}`,
      },
    ],

    navigationBar: {
      back: 'Späť',
      dashboard: 'Nástenka',
      frontpage: 'Predná stránka',
    },

    personDetails: {
      stage: 'Stage',
      namePlaceholder: 'Candidate',
      contact: 'Contact',
      links: 'Links',
      attachments: 'Attachments',
      coverLetter: 'Cover Letter',
      referrer: 'Origin',
      referrerInfo: 'The website from which the candidate came to the service.',
      noStage: 'Not in any stage yet',
      lastSeen: time => `Last seen ${time}.`,
      headerAdditionalInformation: 'Additional information',
      state: {
        invited: 'Invited',
        visited: 'Visited',
        incomplete: 'Incomplete',
        completed: 'Completed',
      },
      notVisited: 'Hasn\'t yet visited the interview.',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `Also found on ${count} other positions`,
    },

    phoneInput: {
      placeholder: example => `Telefónne číslo vo formáte ${example}`,
    },

    questionsAndResponses: {
      response: 'Response',
      noResponse: 'No response',
      resetQuestionResponse: 'Delete candidate response',
      resetQuestionResponseConfirm: questionTitle =>
        `Are you sure you want to reset the question "${questionTitle}" for the candidate and delete their response?`,
      resetQuestionResponseConfirm2: 'If you do this, candidate can retake this question.',
    },

    rating: {
      ownVote: 'Your rating',
      yourVotePlaceholder: 'You have not voted yet.',
      totalVotes: count => `Total ${count} ratings`,
      noRatings: 'No ratings yet',
      mobileModalHeader: 'Add your rating',
      yourRatingReset: 'Reset your vote',
      averageRating: 'Priemerné hodnotenie',
      reset: 'obnoviť',
    },

    share: {
      share: 'Zdieľať na',
      copy: 'Skopírovať odkaz',
    },

    sort: {
      sort: 'Zoradiť',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'Vybraté',
      change: 'Zmeniť',
    },

    video: {
      videoNotFound: 'Video sa spracúva alebo nebolo nájdené',
      retry: 'Skúsiť znova',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Nahrať alebo vytvoriť nové video' : 'Vybrať súbor'),
      videoPlaceholder: 'Nahrajte svoju odpoveď',
      uploadPlaceholderCandidate: 'Nahrať video',
      submit: 'Odoslať odpoveď',
      notAnswered: 'Zatiaľ ste neodpovedali',
      remove: 'Odstrániť pokus',
      converting: 'Video sa konvertuje. Čakajte, prosím...',
      uploading: 'Video sa nahráva. Čakajte, prosím...',
      error: {
        invalid: 'Vybratý súbor je príliš veľký. Vyberte iný súbor.',
        upload: 'Video sa nám nepodarilo nahrať. Ospravedlňujeme sa. Skúste to znova.',
        transcode: 'Vybratý súbor videa bol poškodený alebo nie je platný. Skúste to znova.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Zobraziť viac',
      showLessButtonText: 'Zobraziť menej',
      infoText1:
        'Počas nahrávania nechajte kartu aktívnu na popredí. Nemali by ste pritom používať žiadnu inú aplikáciu.',
      infoText2:
        'Videá s pozadím videa najlepšie fungujú v najaktuálnejších verziách prehliadačov a v zariadení, ktoré je relatívne nové a výkonné.',
      infoText3:
        'Zaistite, aby iné aplikácie nepoužívali váš mikrofóna fotoaparát.',
    },

    videoResponse: {
      videoPlaceholder: 'Zaznamenajte svoju odpoveď',
      uploadPlaceholder: 'Nahrať video',
      submit: 'Odoslať odpoveď',
      notAnswered: 'Zatiaľ ste neodpovedali',
      startInterview: 'Spustiť pohovor',
    },

    webcam: {
      useVideoBgButtonText: 'Použiť pozadie videa',
      removeVideoBgButtonText: 'Odstrániť pozadie videa',
      starting: 'Spúšťa sa...',
      close: 'Zatvoriť kameru',
      remove: 'Odstrániť pokus',
      record: 'Zaznamenať',
      stop: 'Zastaviť',
      retake: 'Opravný',
      submit: 'Odoslať odpoveď',
      converting: 'Video sa konvertuje. Čakajte, prosím...',
      uploading: 'Video sa nahráva Čakajte, prosím...',
      downloading: 'Video sa sťahuje. Čakajte, prosím...',
      processing: 'Spracúva sa...',
      uploadInProgress: 'Prenos videa ešte stále prebieha, nezatvárajte prehliadač ani nemeňte stránku.',
      uploaded: 'Video bolo prenesené.',
      error: {
        DevicesNotFoundError: 'Nie je možné použiť kameru alebo mikrofón. Skontrolujte, či sú povolené.',
        NotFoundError: 'Nie je možné použiť kameru alebo mikrofón. Skontrolujte, či sú povolené.',
        NotAllowedError: 'Neposkytli ste povolenie na používania kamery alebo mikrofónu.',
        PermissionDismissedError: 'Zamietli ste dialógové okno povolenia. Udeľte povolenie na používanie kamery a mikrofónu.',
        PermissionDeniedError: 'Zamietli ste prístup ku kamere alebo mikrofónu.',
        NotReadableError: 'Nie je možné načítavať stream kamery alebo mikrofónu. Môže ísť o chybu hardvéru.',
        SecurityError: 'Vzhľadom na narušenie zabezpečenia nie je možné použiť kameru alebo mikrofón',
        stream: 'Vyskytla sa chyba. Znova spustite svoj prehliadač. Ak bude problém pretrvávať, skúste to znova s odlišným prehliadačom.',
        download: 'Sťahovanie videa zlyhalo. Chcete to skúsiť znova?',
        upload: 'Nahrávanie videa zlyhalo. Chcete to skúsiť znova?',
        emptyBlob: 'Pamäť vášho prehliadača alebo zariadenia je plná a nedokáže vytvoriť nahrávku. Obnovte stránku a ak to nepomôže znova spustite prehliadač. Ak bude problém pretrvávať, skúste iný prehliadač.',
        alternativeRecorder: 'Súbor tiež môžete odovzdať kliknutím sem.',
        reconnecting: 'Spojenie bolo prerušené. Prebieha pokus o opätovné pripojenie.',
      },
    },

    smsMessages: {
      invitationMessage: title =>
        `Ahoj! Chceme ťa pozvať na video rozhovor ${title}! Táto pozvánka bola zaslaná aj na tvoj e-mail. `,
    },
  },
  page: {
    interviewPreview: {
      info: 'This is a preview of the interview. Video recording is disabled and the form data is not saved.',
    },
  },
}
